export default __webpack_public_path__ + "static/char-s-29-zh-Hant-64dc8443494335346e3542cbc863869c.webp";